import React from 'react'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import iconLogo from '../../../assets/images/logo.png'

const RegisterSuccess = () => {
    return (
        <div className="register">
            <header>
                <img alt="" src={iconLogo} />
                <h1>Registration successful!</h1>
                <p>Click <Link to="/auth/login">here</Link> to login</p>
            </header>
        </div>
    )
}

export default RegisterSuccess